export default "./dist/stdassets/images/icons/zoom-in-fixed.png";